
<div>

    <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    
        <h2> {{ aName || 'MAP.MODES.LAYER_PICK_TITLE' | translate }}</h2>

    </div>
    <div class="p-2">
        <table class="w-100 attribTable" *ngIf="meta && !loading">
            <tr *ngFor="let cur of meta">
                <td>{{ cur.key }}</td>
                <td>{{ cur.value }}</td>
            </tr>
        </table>
        <div  *ngIf="!meta && !loading" class="mt-2 alert primary-bg-light  text-center"  translate>
            MAP.MODES.LAYER_PICK_BLANK</div>

        <div class="mt-4 w-100 text-center" *ngIf="loading">
            <mat-spinner style="margin:0 auto;" strokeWidth="3"></mat-spinner>
        </div>
    </div>
</div>  

